import './SubscriptionMetaField.pcss';
import React from 'react';
import classnames from 'classnames';

type Props = {
  label: string;
  value: string | JSX.Element;
  className?: string;
};

export const SubscriptionMetaField = (props: Props) => {
  const { label, value, className } = props;
  const classList = classnames('subscription-meta-field', className);

  return (
    <div className={classList}>
      <div className="subscription-meta-field__label">{label}</div>

      <div className="subscription-meta-field__value">{value}</div>
    </div>
  );
};
